import {Routes} from '@angular/router'
import {onlyAuthenticatedGuard, onlyNotAuthenticatedGuard} from '@core/guards/auth.guard'
import {
  canAccessDeleteCryptoUserPageGuard,
} from './confirm-delete-crypto-user/guards/can-access-delete-crypto-user-page.guard'

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
  },

  {
    path: 'auth',
    canActivate: [onlyNotAuthenticatedGuard],
    children: [
      {
        path: 'sign-in',
        loadComponent: () => import('./sign-in/sign-in.component').then(m => m.SignInComponent),
        title: 'Crypto ID | Connexion',
      },
      {
        path: 'sign-up',
        loadComponent: () => import('./sign-up/sign-up.component').then(m => m.SignUpComponent),
        title: 'Crypto ID | Inscription',
      },
    ],
  },

  {
    path: 'config',
    loadComponent: () => import('./config/config.component').then(m => m.ConfigComponent),
    canActivate: [onlyAuthenticatedGuard],
  },

  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [onlyAuthenticatedGuard],
  },

  {
    path: 'details/:userId',
    loadComponent: () => import('./user-details/user-details.component').then(m => m.UserDetailsComponent),
    canActivate: [onlyAuthenticatedGuard],
  },

  {
    path: 'confirm-delete/:cryptoId',
    loadComponent: () => import('./confirm-delete-crypto-user/confirm-delete-crypto-user.component').then(m => m.ConfirmDeleteCryptoUserComponent),
    canActivate: [onlyAuthenticatedGuard, canAccessDeleteCryptoUserPageGuard],
  },

  {
    path: 'scan/:cryptoId',
    loadComponent: () => import('./scan/scan.component').then(m => m.ScanComponent),
    title: 'Crypto ID | Scan'
  },

  {
    path: 'privacy-policy',
    loadComponent: () => import('./privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
  },

  {
    path: '',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
  },

  {
    path: '**',
    loadComponent: () => import('@core/components/error-404/page-not-found.component').then(m => m.PageNotFoundComponent),
  },
]

